import React, {useState, useRef, useEffect } from "react";
import {
  Grid,
  Box,
  StepLabel,
  Stepper,
  Step,
  AppBar,
  Tabs,
  Tab,
  CircularProgress,
  Typography
} from "@material-ui/core";

import { useHistory, useLocation, Switch, Route, Link, HashRouter } from "react-router-dom";
import useStyles from './styles'
import { sendNotification } from "../../context/UserContext";

import { Button } from '../../components/Wrappers'
import Widget from '../../components/Widget'
import { useUserState } from "../../context/UserContext";
import SelectCustomer from '../../components/Customer/SelectCustomer';
import CreateCustomer from '../../components/Customer/CreateCustomer';
import SelectSite from '../../components/Site/SelectSite';
import CreateSite from '../../components/Site/CreateSite';
import JobDetails from '../../components/JobDetails/JobDetails';
import SelectTechnicians from '../../components/Technician/SelectTechnicians';
import UpdateSite from '../../components/Site/UpdateSite';
import UpdateCustomer from '../../components/Customer/UpdateCustomer';
import JobHistories from '../../components/JobHistories/JobHistories';
import ttAPI from '../../api/ttAPI';
import config from '../../config';

function getSteps() {
    return ['Customer', 'Site', 'Job Details', 'Select Technicians']
}

/*function getStepContent(step) {
    switch (step) {
        case 0:
            return 'Customer'
        case 1:
            return 'Site'
        case 2:
            return 'Job Details'
        case 3:
            return 'Select Technicians'
        default:
            return ''
    }
}*/

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`
  };
}



const AddJob = () => {
    // global
    var { single_phase_price, three_phase_price, rcd_price,
          fire_price, first_aid_price, medical_price, rcd_pb_price,
          lg_pb_price, lg_m_price, three_phase_rcd_price, microwave_price,
          non_electrical_price, ladder_price, aed_price, evse_price,
          hourly_charge, min_charge, local_travel, seventy_hundred_travel,
          over_100_travel, min_cash_charge } = useUserState();
    const history = useHistory();
    const historyRef = useRef(history);
    const location = useLocation();
    const classes = useStyles();
    const steps = getSteps();
    const [activeStep, setActiveStep] = useState(0);
    const [skipped, setSkipped] = useState(new Set());
    const [isBack, setIsBack] = useState(false);
    const [workers, setWorkers] = useState([]);

    // customer related values
    let selectCustomerTabRef;
    let createCustomerTabRef;
    const createCustomerRef = useRef(null);
    const [isSelectCustomerValid, setIsSelectCustomerValid] = useState(false);
    const [isCreateCustomerValid, setIsCreateCustomerValid] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(undefined);
    const [createdCustomer, setCreatedCustomer] = useState({
      id: -1,
      name: undefined,
      company: null,
      contact: null,
      phone: null,
      mobile: null,
      fax: null,
      email: null,
      address: null,
      notes: null,
      mapurl: null,
      testing_scopes: null,
      require_vaccination_proof: false,
      covid_policy: null,
      po_required: false,
      jsa_required: false,
      microwave_only: false,
      service_level_agreement: false,
      agreement_start_date: null,
      agreement_send_date: null,
      price_change_date: null,
      single_phase_price: single_phase_price,
      three_phase_price: three_phase_price,
      rcd_price: rcd_price,
      fire_price: fire_price,
      first_aid_price: first_aid_price,
      medical_price: medical_price,
      rcd_pb_price: rcd_pb_price,
      lg_pb_price: lg_pb_price,
      lg_m_price: lg_m_price,
      three_phase_rcd_price: three_phase_rcd_price,
      microwave_price: microwave_price,
      non_electrical_price: non_electrical_price,
      ladder_price: ladder_price,
      aed_price: aed_price,
      evse_price: evse_price,
      hourly_charge: hourly_charge,
      min_charge: min_charge,
      local_travel: local_travel,
      seventy_hundred_travel: seventy_hundred_travel,
      over_100_travel: over_100_travel,
      min_cash_charge: min_cash_charge,
      repair_email: null,
      health_safety_email: null,
      xero_contact_id: null,
      active: true
    });
    const [customerTabValue, setCustomerTabValue] = React.useState('select-customer');

    // site related values
    let selectSiteTabRef;
    let createSiteTabRef;
    const createSiteRef = useRef(null);
    const [isSelectSiteValid, setIsSelectSiteValid] = useState(false);
    const [isCreateSiteValid, setIsCreateSiteValid] = useState(false);
    const [isCreateJobDetailsValid, setIsCreateJobDetailsValid] = useState(false);
    const [isSelectTechniciansValid, setIsSelectTechniciansValid] = useState(false);
    const [selectedSite, setSelectedSite] = useState(undefined);
    const [createdSite, setCreatedSite] = useState({
      id: -1,
      customer_id: -1,
      name: null,
      code: null,
      contact: null,
      phone: null,
      email: null,
      address: null,
      notes: null,
      mapurl: null,
      active: true
    });
    const [siteTabValue, setSiteTabValue] = React.useState('select-site');

    const [isCreatingNewCustomer, setIsCreatingNewCustomer] = useState(false);
    const [isCreatingNewSite, setIsCreatingNewSite] = useState(false);

    const createJobDetailsRef = useRef(null);
    const selectTechniciansRef = useRef(null);

    const [createdJob, setCreatedJob] = React.useState({
      id: -1,
      customer_d: -1,
      site_id: -1,
      franchise_id: -1,
      code: null,
      contact: null,
      start: '',
      finish: '',
      instructions: null,
      tag: '',
      leader: -1,
      workers:[],
      is_in_region: 'YES'
    });
    const [isSaving, setIsSaving] = useState(false);
    const [isSavingAndConfirming, setIsSavingAndConfirming] = useState(false);
    const [oldJobId, setOldJobId] = useState(-1);
    const [siteInfoTabValue, setSiteInfoTabValue] = useState(1);
    const [customerInfoTabValue, setCustomerInfoTabValue] = useState(0);
    const [isRefetchingCustomer, setIsRefetchingCustomer] = useState(false);
    const [isRefetchingSite, setIsRefetchingSite] = useState(false);
    const [testScopesDirty, setTestScopesDirty] = useState(1);


    useEffect(() => {
        return historyRef.current.listen((location) => {
            if (location.pathname.endsWith('select-site')) {
                setSiteTabValue('select-site');
            }
            else if (location.pathname.endsWith('create-site')) {
                setSiteTabValue('create-site');
            }
            else if (location.pathname.endsWith('add') || location.pathname.endsWith('add/')) {
                window.location.reload();
            }
        })
    },[]);

    useEffect(() => {
      const fetchCustomerById = async(id) => {
        const response = await ttAPI.getCustomerById(id);
        setSelectedCustomer(response);
        setIsRefetchingCustomer(false);
      };

      const fetchSiteById = async(id) => {
        const response = await ttAPI.getSiteById(id);
        setSelectedSite(response);
        setIsRefetchingSite(false);
      };
      // the isBack part will be triggered by handleBack()
      if (isBack) {
        if (activeStep === 0) {
          if (isCreatingNewCustomer) {
              history.push('/app/job/add/create-customer');
          }
          else {
              history.push('/app/job/add/select-customer');
          }
        }
        else if (activeStep === 1) {
          if (isCreatingNewSite) {
              history.push('/app/job/add/create-site');
          }
          else {
              history.push('/app/job/add/select-site');
          }
        }
        else if (activeStep === 2) {
            history.push('/app/job/add/job-details');
        }
      }
      else {
        if (activeStep === 1) {
          if (isCreatingNewSite) {
              history.push('/app/job/add/create-site');
          }
          else {
              history.push('/app/job/add/select-site');
          }
        }
        else if (activeStep === 2) {
            history.push('/app/job/add/job-details');
            if (!isCreatingNewCustomer) {
                // load full customer details for job details step
                setIsRefetchingCustomer(true);
                fetchCustomerById(selectedCustomer.id);
            }
            if (!isCreatingNewSite) {
                setIsRefetchingSite(true);
                fetchSiteById(selectedSite.id);
            }
        }
        else if (activeStep === 3) {
            history.push('/app/job/add/select-technicians');
        }
      }

    },[activeStep]);

    useEffect(() => {
      // on first page load, select the select-customer tab
      if (location.pathname.endsWith('select-customer') || location.pathname.endsWith('add') || location.pathname.endsWith('add/')) {
          selectCustomerTabRef.click();
      }
      else if (location.pathname.endsWith('create-customer')) {
          createCustomerTabRef.click();
      }
    }, []);

    useEffect(() => {
      let mounted = true;

      const fetchCustomerById = async(id) => {
        const response = await ttAPI.getCustomerById(id);
        if(mounted){
           setSelectedCustomer(response);
           localStorage.removeItem('add_job_from_customer_selected_customer');
        }
      };

      if (location.pathname.endsWith('select-site')) {
        if (selectSiteTabRef === undefined) {
          //console.log(selectSiteTabRef);
          // redirect back to first step
          history.push('/app/job/add/select-customer');
        }
        /*else {
          selectSiteTabRef.click();
        }*/
      }
      else if (location.pathname.endsWith('create-site')) {
        if (createSiteTabRef === undefined) {
            // redirect back to first step
            history.push('/app/job/add/select-customer');
        }
        /*else {
            createSiteTabRef.click();
            setSiteTabValue('create-site');
        }*/

      }
      else if (location.pathname.endsWith('job-details')) {
        // redirect back to first step
        history.push('/app/job/add/select-customer');
      }
      else if (location.pathname.endsWith('select-technicians')) {
        // redirect back to first step
        history.push('/app/job/add/select-customer');
      }
      else if (location.pathname.endsWith('select-customer')) {
        if (selectedCustomer === undefined &&
            localStorage.getItem('add_job_from_customer_selected_customer') !== undefined &&
            localStorage.getItem('add_job_from_customer_selected_customer') !== null &&
            !isNaN(parseInt(localStorage.getItem('add_job_from_customer_selected_customer')))) {
                fetchCustomerById(
                  parseInt(
                    localStorage.getItem('add_job_from_customer_selected_customer')
                ));
            }
      }



      return () => mounted = false;

    }, []);

    useEffect(() => {
        var customerId = -1;
        var jsaRequired = null;
        var microwaveOnly = null;
        if (!isCreatingNewCustomer && selectedCustomer !== undefined && selectedCustomer.id > 0) {
            customerId = selectedCustomer.id;
            jsaRequired = selectedCustomer.jsa_required;
            microwaveOnly = selectedCustomer.microwave_only;
        }
        else if (isCreatingNewCustomer && createdCustomer.id) {
            customerId = createdCustomer.id;
            jsaRequired = createdCustomer.jsa_required;
            microwaveOnly = createdCustomer.microwave_only;
        }

        if (customerId > 0) {

          setCreatedSite({
            ...createdSite,
            customer_id: customerId,
          });



          setCreatedJob({
            ...createdJob,
            customer_id: customerId,
            jsa_required: jsaRequired,
            microwave_only: microwaveOnly
          });
        }

    }, [selectedCustomer]);

    useEffect(() => {
        var siteId = -1;
        var contact = '';
        var phone = '';
        var email = '';
        var testingScopes = '';
        var testingScopeOtherNotes = '';
        if (!isCreatingNewSite && selectedSite !== undefined && selectedSite.id > 0) {
            siteId = selectedSite.id;
            contact = `${selectedSite.contact !== null && selectedSite.contact !== undefined && selectedSite.contact !== '' ? `${selectedSite.contact} ` : ''}`;
            phone = `${selectedSite.phone !== null && selectedSite.phone !== undefined && selectedSite.phone !== '' ? `${selectedSite.phone} ` : ''}`;
            email = `${selectedSite.email !== null && selectedSite.email !== undefined && selectedSite.email !== '' ? `${selectedSite.email} ` : ''}`;
            contact = `${contact}${phone}${email}`;
            testingScopes = selectedSite.testing_scopes;
            testingScopeOtherNotes = selectedSite.testing_scope_other_notes;
        }
        else if (isCreatingNewSite && createdSite.id) {
            siteId = createdSite.id;
            contact = `${createdSite.contact !== null && createdSite.contact !== undefined && createdSite.contact !== '' ? `${createdSite.contact} ` : ''}`;
            phone = `${createdSite.phone !== null && createdSite.phone !== undefined && createdSite.phone !== '' ? `${createdSite.phone} ` : ''}`;
            email = `${createdSite.email !== null && createdSite.email !== undefined && createdSite.email !== '' ? `${createdSite.email} ` : ''}`;
            contact = `${contact}${phone}${email}`;
            testingScopes = createdSite.testing_scopes;
            testingScopeOtherNotes = createdSite.testing_scope_other_notes;
        }

        if (siteId > 0) {
          const hasTELtag = Array.isArray(testingScopes) && testingScopes.some(scope =>
            typeof scope === 'object' ? scope.id === 11 : scope === 11
          );
          setCreatedJob({
            ...createdJob,
            site_id: siteId,
            contact: contact === '' ? null : contact,
            testing_scopes: testingScopes,
            testing_scope_other_notes: testingScopeOtherNotes,
            ...(hasTELtag && {
              is_nfc: true,
              is_cataloguing: true,
            }),
          });
        }

    }, [selectedSite]);

    useEffect(() => {
        if (createdSite !== undefined && createdSite.id > 0) {
          var contact = `${createdSite.contact !== null && createdSite.contact !== undefined && createdSite.contact !== '' ? `${createdSite.contact} ` : ''}`;
          var phone = `${createdSite.phone !== null && createdSite.phone !== undefined && createdSite.phone !== '' ? `${createdSite.phone} ` : ''}`;
          var email = `${createdSite.email !== null && createdSite.email !== undefined && createdSite.email !== '' ? `${createdSite.email} ` : ''}`;
          contact = `${contact}${phone}${email}`

          const hasTELtag = Array.isArray(createdSite.testing_scopes) && createdSite.testing_scopes.some(scope =>
            typeof scope === 'object' ? scope.id === 11 : scope === 11
          );

          setCreatedJob({
            ...createdJob,
            contact: contact,
            testing_scopes: createdSite.testing_scopes,
            testing_scope_other_notes: createdSite.testing_scope_other_notes,
            ...(hasTELtag && {
              is_nfc: true,
              is_cataloguing: true,
            }),
          });
        }
    }, [createdSite]);

    useEffect(() => {
        let mounted = true;

        async function fetchData() {
          const siteId = isCreatingNewSite ? createdSite.id : selectedSite.id;
          var response = await ttAPI.loadRetest(null,siteId);

            /*if (response && response !== null) {
                if(mounted){
                    setOldJobId(response.job_id === null || response.job_id === undefined ? response.id : response.job_id);
                }
            }*/

            if (response && response !== null && response.job_id !== null && response.job_id !== undefined) {
                if(mounted){
                  setOldJobId(response.job_id);
                }
            }
        }

        if (mounted &&
            ((isCreatingNewSite && createdSite !== undefined && createdSite !== null &&
             createdSite.id !== undefined && createdSite.id !== null && createdSite.id > 0) ||
            (!isCreatingNewSite && selectedSite !== undefined && selectedSite !== null &&
              selectedSite.id !== undefined && selectedSite.id !== null && selectedSite.id > 0)))
             {
            fetchData();
        }

        return () => mounted = false;
    },[createdSite, selectedSite, isCreatingNewSite]);

    function handleCallToRouter(value) {
      history.push(value);
    }

    function handleCustomerTabChange(event, newValue) {
      setCustomerTabValue(newValue);

      if (newValue === 'select-customer') {
        setIsSelectCustomerValid(false);
      }
      else if (newValue === 'create-customer') {
        setIsCreateCustomerValid(true);
      }
    }

    function handleSiteTabChange(event, newValue) {
      setSiteTabValue(newValue);

      if (newValue === 'select-site') {
        setIsSelectSiteValid(false);
      }
      else if (newValue === 'create-site') {
        setIsCreateSiteValid(true);
      }
    }


    /*function extractExtensionFrom(filename) {
      if (!filename) {
        return null;
      }

      const regex = /(?:\.([^.]+))?$/;
      return regex.exec(filename)[1];
    }



    const handleFile = async (event) => {
      const file = event.target.files[0];

      const extension = extractExtensionFrom(file.name);
      const id = uuid();
      const filename = `${id}.${extension}`;
      return ;
    }*/
    const isStepSkipped = step => {
        return skipped.has(step)
    }

    //var managementDispatch = useManagementDispatch()

    const handleFinishAndConfirm = async () => {
      await handleFinish(true);
    }

    const handleFinish = async (isConfirmed) => {
        const jobToSend = createdJob;

        if (isConfirmed !== undefined && isConfirmed) {
            jobToSend.confirmed = true;
        }

        if (jobToSend.workers) {
            jobToSend.workers = jobToSend.workers.map(worker => worker.id === undefined ? worker : worker.id);
        }
        if (jobToSend.testing_scopes !== undefined && jobToSend.testing_scopes !== null) {
            jobToSend.testing_scopes = jobToSend.testing_scopes.map(testing_scope => isNaN(testing_scope) ? testing_scope.id : testing_scope);

            const isTELtag = jobToSend.testing_scopes?.some(scope =>
              typeof scope === 'object' ? scope.id === 11 : scope === 11
            );

            // the following two setups must come with TELtag
            if (isTELtag) {
              jobToSend.is_nfc = true;
              jobToSend.is_cataloguing = true;
            }
        }
        jobToSend.start = jobToSend.start.replace('T', ' ');
        jobToSend.finish = jobToSend.finish.replace('T', ' ');
        if (jobToSend.start.split(':').length === 2) {
            jobToSend.start = jobToSend.start.concat(':00');
        }

        if (jobToSend.finish.split(':').length === 2) {
            jobToSend.finish = jobToSend.finish.concat(':00');
        }
        if (isConfirmed !== undefined && isConfirmed) {
            setIsSavingAndConfirming(true);
        }
        else {
            setIsSaving(true);
        }

        const response = await ttAPI.saveJob(jobToSend);
        if (response.id > 0) {
          if (isConfirmed !== undefined && isConfirmed) {
              ttAPI.sendJobSheet(response.id);
              if (localStorage.getItem('auto_open_teams_link_after_job_confirmation') === 'true') {
                  openTeamChatWithJobCardLink(response.id, response.jobcard_token);
              }
              setIsSavingAndConfirming(false);
          }
          else {
              setIsSaving(false);
          }
          /*history.push({
            pathname: '/app/jobs',
            state:{jobId: response}
          });*/
          history.push({
            pathname:`/app/job/edit/${response.id}`,
            state:{jobId: response.id, isFromCreateJob: true}
          });
        }
        else {
          if (isConfirmed !== undefined && isConfirmed) {
              setIsSavingAndConfirming(false);
          }
          else {
              setIsSaving(false);
          }
          sendNotification('error', `${response.error}`, classes );
        }
    }

    const openTeamChatWithJobCardLink = async (jobId, jobcard_token) => {
      var emails = await ttAPI.getJobWorkerEmails(jobId);
      if (emails !== null && emails !== undefined && emails !== '' && emails !== 'null') {
        window.open(
        `${config.teamChatWithMessageUrl.replace('<USERS>', emails).replace('<TOPIC_NAME>',`Job%20${jobId}%20Chat`).replace('<CONTENT>',`Job ${jobId} has been confirmed. An email was sent and you can download a copy of the job card from here as well: ${config.clientApi}/dashboard/job_sheet?jobId=${jobId}${encodeURIComponent('&')}jobcard_token=${jobcard_token}`)}`,
        '_blank'
        );
      }
      else {
        sendNotification('error','Cannot open a team chat as there are no technicians are assigned to the job.', classes);
      }
    }

    const handleNext = async () => {
        setIsBack(false);
        var hasError = false;
        // customer step
        if (activeStep === 0) {
          if (customerTabValue === 'create-customer') {
              setIsCreatingNewCustomer(true);
              createCustomerRef.current.saveCustomer();
          }
          else {
              setIsCreatingNewCustomer(false);
          }
        }
        else if (activeStep === 1) {
          if (siteTabValue === 'create-site') {
              setIsCreatingNewSite(true);
              createSiteRef.current.saveSite();
          }
          else {
              setIsCreatingNewSite(false);
          }

        }
        else if (activeStep === 2) {
            if (createJobDetailsRef !== null && createJobDetailsRef.current !== null) {
                createJobDetailsRef.current.saveJobDetails();
            }
        }
        else if (activeStep === 3) {
            if (selectTechniciansRef !== null && selectTechniciansRef.current !== null) {
                selectTechniciansRef.current.saveTechs();
            }
        }


        if (!hasError) {
          if (activeStep === 0 && customerTabValue === 'create-customer') {
              // do nothing here, need to wait till the customer is created to call setStep()
          }
          else if (activeStep === 1 && siteTabValue === 'create-site') {
             // do nothing here, need to wait till the site is created to call setStep()
          }
          else {
             setStep();
          }

        }

    }

    function setStep() {
      let newSkipped = skipped
      if (isStepSkipped(activeStep)) {
          newSkipped = new Set(newSkipped.values())
          newSkipped.delete(activeStep)
      }

      setActiveStep(prevActiveStep => prevActiveStep + 1)
      setSkipped(newSkipped)
    }

    const handleBack = () => {
      setIsBack(true);
      setActiveStep(prevActiveStep => prevActiveStep - 1);
    }

    function onSelectCustomer(customer) {
      setSelectedCustomer(customer);
    }

    function onSelectCustomerFormUpdated(isValid) {
      setIsSelectCustomerValid(isValid);
    }

    function onCreateCustomerFormUpdated(isValid) {
      setIsCreateCustomerValid(isValid);
    }

    function onCreateCustomerUpdated(customer) {
      setCreatedCustomer(customer);
    }

    function onCustomerCreated(customer, isUpdate, customerId) {
      sendNotification('success', isUpdate ? 'Success - Customer Updated.' : 'Success - Customer Created.', classes);
      setCreatedCustomer(customer);

      if (customer !== undefined && customer !== null) {
          setCreatedSite({
            ...createdSite,
            customer_id: customerId,
          });



        setCreatedJob({
          ...createdJob,
          customer_id: customerId,
          jsa_required: customer.jsa_required,
          microwave_only: customer.microwave_only
        });
      }

      // move onto sites
      // since it's a new customer then it means you need to create new site
      setIsCreatingNewSite(true);
      setSiteTabValue('create-site');
      handleCallToRouter('/app/job/add/create-site');
      setStep();

    }

    const disableCustomerStepNextButton = () => {
      if (customerTabValue === 'select-customer') {
        return !isSelectCustomerValid;
      }
      else if (customerTabValue === 'create-customer') {
        return !isCreateCustomerValid;
      }
      return true;
    }

    async function onRegionSelected(regionId) {
      if (createdJob.is_in_region && regionId > 0) {
        const response = await ttAPI.getActiveWorkersByRegion(regionId);
        setWorkers(response);
      }
      else {
        const response = await ttAPI.getActiveWorkers();
        setWorkers(response);
      }
      if (selectTechniciansRef.current) {
        selectTechniciansRef.current.updateLeaderWokersSelection(createdJob.is_in_region);
      }
    }

    async function onIsInRegionSelected(isInRegionValue) {
        setCreatedJob({
          ...createdJob,
          is_in_region: isInRegionValue === 'YES'
        });
       if (isInRegionValue === 'YES' && createdJob !== undefined && createdJob !== null && createdJob.franchise_id > 0) {
         const response = await ttAPI.getActiveWorkersByRegion(createdJob.franchise_id);
         setWorkers(response);
       }
       else {
         const response = await ttAPI.getActiveWorkers();
         setWorkers(response);
       }
       if (selectTechniciansRef.current) {
         selectTechniciansRef.current.updateLeaderWokersSelection(isInRegionValue);
       }
    }

    function onSelectSite(site) {
      setSelectedSite(site);
    }

    function onSelectSiteFormUpdated(isValid) {
      setIsSelectSiteValid(isValid);
    }

    function onCreateSiteFormUpdated(isValid) {
      setIsCreateSiteValid(isValid);
    }

    function onCreateSiteUpdated(site) {
      setCreatedSite(site);
    }

    function onSiteCreated(site, isUpdate, siteId) {
        sendNotification('success', isUpdate ? 'Success - Site Updated.' : 'Success - Site Created.', classes)
        setCreatedSite(site);

        if (siteId > 0) {
          setCreatedJob({
            ...createdJob,
            site_id: siteId,
            testing_scopes: site.testing_scopes,
            testing_scope_other_notes: site.testing_scope_other_notes
          });
        }
        setStep();
    }

    function onCreateJobDetailsFormUpdated(isValid) {
        setIsCreateJobDetailsValid(isValid);
    }

    function onCreateJobDetailsUpdated(job) {
          setCreatedJob(job);
    }

    function onJobDetailsCreated(job) {
        setCreatedJob(job);
    }

    function onSelectTechniciansFormUpdated(isValid) {
        setIsSelectTechniciansValid(isValid);
    }

    function onTechniciansSelected(workers) {
        setCreatedJob({
          ...createdJob,
          workers: workers,
        });
    }

    function onLeaderSelected(leader) {
        setCreatedJob({
          ...createdJob,
          leader: leader
        });
        setIsSelectTechniciansValid(true);
    }

    const disableSiteStepNextButton = () => {
      if (siteTabValue === 'select-site') {
        return !isSelectSiteValid;
      }
      else if (siteTabValue === 'create-site') {
        return !isCreateSiteValid;
      }
      return true;
    }

    const disableJobDetailsStepNextButton = () => {
      return !isCreateJobDetailsValid;
    }

    const disableSelectTechniciansStepNextButton = () => {
      return !isSelectTechniciansValid || isSaving || isSavingAndConfirming
    }

    const handleStepperClicked = (stepClicked) => {

      if (stepClicked < activeStep) {
        // go back is fine, no validation
        if (stepClicked === 0) {
          if (isCreatingNewCustomer) {
              handleCallToRouter('/app/job/add/create-customer');
          }
          else {
              handleCallToRouter('/app/job/add/select-customer');
          }
        }
        else if (stepClicked === 1) {
          if (siteTabValue === 'create-site') {
              setIsCreatingNewSite(true);
              if (createSiteRef !== null && createSiteRef.current !== null) {
                  createSiteRef.current.saveSite();
              }
          }
          else {
              setIsCreatingNewSite(false);
          }

        }
        else if (stepClicked === 2) {
            if (createJobDetailsRef !== null && createJobDetailsRef.current !== null) {
                createJobDetailsRef.current.saveJobDetails();
            }
        }

        setActiveStep(stepClicked)
      }
      else if (stepClicked > activeStep) {
        // going forward need validation checks
        if (activeStep === 0) {
          if (customerTabValue === 'create-customer' && isCreateCustomerValid) {
              setIsCreatingNewCustomer(true);
              if (createCustomerRef !== null && createCustomerRef.current !== null) {
                  createCustomerRef.current.saveCustomer();
              }
              setActiveStep(stepClicked);
          }
          else if (customerTabValue === 'select-customer' && isSelectCustomerValid) {
              setIsCreatingNewCustomer(false);
              setActiveStep(stepClicked);
          }
        }
        else if (activeStep === 1) {
          if (siteTabValue === 'create-site' && isCreateSiteValid) {
              setIsCreatingNewSite(true);
              if (createSiteRef !== null && createSiteRef.current !== null) {
                  createSiteRef.current.saveSite();
              }
              setActiveStep(stepClicked);
          }
          else if (siteTabValue === 'select-site' && isSelectSiteValid) {
              setIsCreatingNewSite(false);
              setActiveStep(stepClicked);
          }
        }
        else if (activeStep === 2) {
              if (isCreateJobDetailsValid) {
                  if (createJobDetailsRef !== null && createJobDetailsRef.current !== null) {
                      createJobDetailsRef.current.saveJobDetails();
                  }
                  setActiveStep(stepClicked);
              }
        }
      }
    }

    function getIsInRegion() {
      return createdJob.is_in_region;
    }

    function getSiteName() {
        if (siteTabValue === 'create-site') {
          return createdSite !== undefined && createdSite !== null ? createdSite.name : '';
        }
        return selectedSite !== undefined && selectedSite !== null ? selectedSite.name : '';
    }

    function onUpdateSiteSuccess() {

    }

    function onUpdateCustomerSuccess() {

    }

    function handleSiteInfoTabChange(event, newValue) {
      setSiteInfoTabValue(newValue);
    }

    function handleCustomerInfoTabChange(event, newValue) {
      setCustomerInfoTabValue(newValue);
    }

    function onTestingScopesChanged(testingScopes) {
        if (selectTechniciansRef.current) {
            selectTechniciansRef.current.updateTestingScopes(testingScopes);
        }
        setTestScopesDirty(Math.random());
    }

    return (<>
        <Grid container spacing={1}>
            <Grid item xs={12}>{/*${isCreatingNewSite ? (createdSite ? ' - ' + createdSite.name : '') : (selectedSite ? ' - ' + selectedSite.name : '')}*/}
                <Widget title={`Create Job ${isCreatingNewCustomer ? ((createdCustomer !== undefined && createdCustomer !== null) ? (' - ' + createdCustomer.name) : '') : ((selectedCustomer !== undefined && selectedCustomer !== null) ? (' - ' + selectedCustomer.name) : '')} ${isCreatingNewSite ? ((createdSite !== undefined && createdSite !== null) ? ' - ' + createdSite.name : '') : ((selectedSite !== undefined && selectedSite !== null) ? ' - ' + selectedSite.name : '')}`} disableWidgetMenu>
                    <Stepper activeStep={activeStep} className={classes.stepper}>
                        {steps.map((label, index) => {
                            const stepProps = {}
                            const labelProps = {}
                            if (isStepSkipped(index)) {
                                stepProps.completed = false
                            }
                            return (
                                <Step key={label} {...stepProps}>
                                    <StepLabel {...labelProps} classes={{completed: classes.stepCompleted}}>

                                        <Button className={classes.stepperButton}
                                            onClick={() => handleStepperClicked(index)}
                                        >
                                            {label}
                                        </Button>
                                    </StepLabel>
                                </Step>
                            )
                        })}
                    </Stepper>
                </Widget>
            </Grid>
            <Grid item xs={12}>
                <Widget disableWidgetMenu noHeader>

                    <Grid item justify={'center'} container>

                        <Box
                            display={'flex'}
                            flexDirection={'column'}
                            width={activeStep === 2 ? '50%' : '100%'}
                        >
                        {/*<div>{`job.id is ${createdJob.id}`}</div>
                        <div>{`job.customerId is ${createdJob.customer_id}`}</div>
                        <div>{`job.siteId is ${createdJob.site_id}`}</div>
                        <div>{`job.regionId is ${createdJob.franchise_id}`}</div>
                        <div>{`job.tag is ${createdJob.tag}`}</div>
                        <div>{`job.start is ${createdJob.start}`}</div>
                        <div>{`job.finish is ${createdJob.finish}`}</div>
                        <div>{`job.contact is ${createdJob.contact}`}</div>
                        <div>{`job.leader is ${createdJob.leader}`}</div>
                        <div>{`job.is_in_region is ${createdJob.is_in_region}`}</div>*/}
                            {/*}<Typography
                                variant={'h5'}
                                weight={'medium'}
                                style={{ marginBottom: 30 }}
                            >
                                {getStepContent(activeStep)}
                            </Typography>*/}
                            {activeStep === 0 ? (
                                <>
                                {/* <div>{`test: ${location.pathname}`}</div>
                                <div>{`test: ${location.pathname}/${customerTabValue}`}</div>*/}
                                <Widget title="" disableWidgetMenu noShadow inheritHeight noHeader>
                                <HashRouter>
                                  <AppBar position="static" color="default" style={{ marginTop: 10 }}>
                                          <Tabs value={customerTabValue}
                                                onChange={handleCustomerTabChange}
                                                indicatorColor="primary"
                                                textColor="primary"
                                                variant="fullWidth">
                                            <Tab {...a11yProps(0)} ref={ref => selectCustomerTabRef = ref}
                                                                   label="SELECT CUSTOMER"
                                                                   value="select-customer"
                                                                   component={Link}
                                                                   to="/app/job/add/select-customer" />
                                            <Tab {...a11yProps(1)} ref={ref => createCustomerTabRef = ref}
                                                                   label="CREATE CUSTOMER"
                                                                   value="create-customer"
                                                                   component={Link}
                                                                   to="/app/job/add/create-customer" />
                                          </Tabs>
                                        </AppBar>
                                          <Grid item justify={'center'} className={classes.tabContent} container>
                                          <Switch>
                                            <Route path="/app/job/add/select-customer">
                                                <SelectCustomer labelName="Search Customer"
                                                                selectedCustomer={selectedCustomer}
                                                                onSelect={onSelectCustomer}
                                                                onFormUpdated={onSelectCustomerFormUpdated}/>
                                            </Route>
                                            <Route path="/app/job/add/create-customer">
                                                 <CreateCustomer ref={createCustomerRef}
                                                                 createdCustomer={createdCustomer}
                                                                 onFormUpdated={onCreateCustomerFormUpdated}
                                                                 onCustomerUpdated={onCreateCustomerUpdated}
                                                                 onCustomerCreated={onCustomerCreated}/>
                                            </Route>
                                          </Switch>
                                          </Grid>

                                </HashRouter>
                                </Widget>
                                </>
                            ) : activeStep === 1 ? (
                                <>
                                 {/*}<div>{`test: ${location.pathname}`}</div>
                                <div>{`test: ${location.pathname}/${siteTabValue}`}</div>*/}
                                <Widget title="" disableWidgetMenu noShadow inheritHeight noHeader>
                                <HashRouter>
                                  <AppBar position="static" color="default" style={{ marginTop: 10 }}>
                                          <Tabs value={siteTabValue}
                                                onChange={handleSiteTabChange}
                                                indicatorColor="primary"
                                                textColor="primary"
                                                variant="fullWidth">
                                            <Tab {...a11yProps(0)} ref={ref => selectSiteTabRef = ref}
                                                                   label="SELECT SITE"
                                                                   value="select-site"
                                                                   component={Link}
                                                                   to="/app/job/add/select-site" />
                                            <Tab {...a11yProps(1)} ref={ref => createSiteTabRef = ref}
                                                                   label="CREATE SITE"
                                                                   value="create-site"
                                                                   component={Link}
                                                                   to="/app/job/add/create-site" />
                                          </Tabs>
                                        </AppBar>
                                          <Grid item justify={'center'} className={classes.tabContent} container>
                                          <Switch>
                                            <Route path="/app/job/add/select-site">
                                                <SelectSite selectedSite={selectedSite}
                                                            customerId={isCreatingNewCustomer ? createdCustomer.id : selectedCustomer.id}
                                                            onSelect={onSelectSite}
                                                            onFormUpdated={onSelectSiteFormUpdated}/>
                                            </Route>
                                            <Route path="/app/job/add/create-site">
                                                 <CreateSite ref={createSiteRef}
                                                             createdSite={createdSite}
                                                             onFormUpdated={onCreateSiteFormUpdated}
                                                             onSiteUpdated={onCreateSiteUpdated}
                                                             onSiteCreated={onSiteCreated}/>
                                            </Route>
                                          </Switch>
                                          </Grid>

                                </HashRouter>
                                </Widget>
                                </>
                            ) : activeStep === 2 ? (
                                <>
                                <Switch>
                                  <Route path="/app/job/add/job-details">
                                  <Grid container justify={'center'} style={{marginBottom: '20px', padding: '30px'}}>
                                    <Grid item xs={12} md={12} sm={12}>
                                            <JobDetails ref={createJobDetailsRef}
                                                isAddJob={true}
                                                selectedCustomer={isCreatingNewCustomer ? createdCustomer : selectedCustomer}
                                                createdJob={createdJob}
                                                onFormUpdated={onCreateJobDetailsFormUpdated}
                                                onJobDetailsUpdated={onCreateJobDetailsUpdated}
                                                onJobDetailsCreated={onJobDetailsCreated}
                                                onRegionSelected={onRegionSelected}
                                                onIsInRegionSelected={onIsInRegionSelected}
                                                getSiteName={getSiteName}
                                                onTestingScopesChanged={onTestingScopesChanged}
                                                />
                                    </Grid>

                                    </Grid>
                                  </Route>
                                </Switch>
                                </>
                            ) : (
                                <>
                                <Switch>
                                  <Route path="/app/job/add/select-technicians">
                                    <div style={{padding: '16px'}}>
                                  {/*((!isCreatingNewCustomer && selectedCustomer !== undefined && selectedCustomer.id > 0 && selectedCustomer.require_vaccination_proof) ||
                                    (isCreatingNewCustomer && createdCustomer.id && createdCustomer.require_vaccination_proof)) &&
                                    <div style={{color: '#f44336', marginTop: '-10px', marginBottom: '10px'}}>Proof of vaccination required!</div>*/}
                                    <SelectTechnicians ref={selectTechniciansRef}
                                                       isAddJob={true}
                                                       getIsInRegion={getIsInRegion}
                                                       createdJob={createdJob}
                                                       onFormUpdated={onSelectTechniciansFormUpdated}
                                                       workers={workers}
                                                       onTechniciansSelected={onTechniciansSelected}
                                                       onLeaderSelected={onLeaderSelected}
                                                       dirty={testScopesDirty}/></div>
                                    <div style={{marginBottom: '20px'}}></div>
                                  </Route>
                                </Switch>
                                </>
                            )}
                            <div className={classes.bottomMenu}>
                                <div>
                                    {activeStep === 0 ? (
                                        <Box
                                            display={'flex'}
                                            justifyContent={'flex-end'}
                                        >
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                disabled={disableCustomerStepNextButton()}
                                                onClick={handleNext}
                                            >
                                                Next
                                            </Button>
                                        </Box>
                                      ) : activeStep === 1 ? (
                                        <Box
                                            display={'flex'}
                                            justifyContent={'flex-end'}
                                        >
                                            <Button
                                                onClick={handleBack}
                                                className={classes.backButton}
                                            >
                                                Back
                                            </Button>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                disabled={disableSiteStepNextButton()}
                                                onClick={handleNext}
                                            >
                                                Next
                                            </Button>
                                        </Box>
                                    ) : activeStep === 2 ? (
                                        <Box
                                            display={'flex'}
                                            justifyContent={'flex-end'}
                                        >
                                            <Button
                                                onClick={handleBack}
                                                className={classes.backButton}
                                            >
                                                Back
                                            </Button>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                disabled={disableJobDetailsStepNextButton()}
                                                onClick={handleNext}
                                            >
                                                {activeStep === steps.length - 1
                                                    ? 'Finish'
                                                    : 'Next'}
                                            </Button>
                                        </Box>
                                    ) :(
                                        <Box
                                            display={'flex'}
                                            justifyContent={'flex-end'}
                                        >
                                            <Button
                                                className={classes.backButton}
                                                onClick={handleBack}
                                            >
                                                Back
                                            </Button>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                disabled={disableSelectTechniciansStepNextButton()}
                                                onClick={() => handleFinish(false)}
                                            >
                                                {isSaving && <span><CircularProgress size={25}/> Creating...</span>}
                                                {!isSaving && <span>Finish</span>}
                                            </Button>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                disabled={disableSelectTechniciansStepNextButton()}
                                                onClick={handleFinishAndConfirm}
                                                style={{marginLeft: '10px'}}
                                            >
                                                {isSavingAndConfirming && <span><CircularProgress size={25}/> Finish & Confirming...</span>}
                                                {!isSavingAndConfirming && <span>Finish & Confirm</span>}
                                            </Button>
                                        </Box>
                                    )}
                                </div>
                            </div>
                        </Box>

                        <Box display={'flex'}
                             flexDirection={'column'}
                             width={activeStep === 2 ? '50%' : '100%'}>
                        {activeStep === 2 &&
                          <Grid justify={'center'} container>
                              {!isRefetchingSite && ((!isCreatingNewSite && selectedSite && selectedSite.id > 0) || (isCreatingNewSite && createdSite && createdSite.id > 0)) &&
                                <Grid item xs={12} md={12} sm={12}>
                                <Widget
                                 className={classes.formDisplay}
                                 disableWidgetMenu noHeader>
                                 <AppBar position="static" color="default" style={{ marginTop: 10 }}>
                                   <Tabs value={siteInfoTabValue}
                                         onChange={handleSiteInfoTabChange}
                                         indicatorColor="primary"
                                         textColor="primary"
                                         variant="fullWidth">
                                     <Tab {...a11yProps(0)} label="SITE NOTES"
                                                            value={0}/>
                                     <Tab {...a11yProps(1)} label="HISTORY"
                                                            value={1}/>
                                     <Tab {...a11yProps(2)} label="SITE DETAILS"
                                                            value={2}/>
                                   </Tabs>
                                 </AppBar>
                                 {/*<TabPanel value={siteTabValue} index={0}>
                                    <UpdateSite key={selectedSite.id} isNotesOnly={true} createdSite={selectedSite} onUpdateSuccess={onUpdateSiteSuccess}/>
                                  </TabPanel>
                                   */}

                                   <div
                                     role="tabpanel"
                                     id="simple-tabpanel-0"
                                     aria-labelledby="simple-tab-0"
                                   >
                                     {siteInfoTabValue === 0 && (
                                       <Box p={3}>
                                         <Typography component="div">
                                         <UpdateSite key={isCreatingNewSite ? createdSite.id : selectedSite.id} isNotesOnly={true} createdSite={isCreatingNewSite ? createdSite : selectedSite} onUpdateSuccess={onUpdateSiteSuccess}/>
                                         </Typography>
                                       </Box>
                                     )}
                                   </div>
                                   <div
                                     role="tabpanel"
                                     id="simple-tabpanel-1"
                                     aria-labelledby="simple-tab-1"
                                   >
                                     {siteInfoTabValue === 1 && (
                                       <Box p={3}>
                                         <Typography component="div">
                                          <JobHistories key={isCreatingNewSite ? createdSite.id : selectedSite.id} jobId={oldJobId}/>
                                         </Typography>
                                       </Box>
                                     )}
                                   </div>
                                   {/*<TabPanel value={siteTabValue} index={2}>
                                     <UpdateSite key={selectedSite.id} createdSite={selectedSite} onUpdateSuccess={onUpdateSiteSuccess}/>
                                   </TabPanel>*/}
                                   <div
                                     role="tabpanel"
                                     id="simple-tabpanel-2"
                                     aria-labelledby="simple-tab-2"
                                   >
                                     {siteInfoTabValue === 2 && (
                                       <Box p={3}>
                                         <Typography component="div">
                                          <UpdateSite key={isCreatingNewSite ? createdSite.id : selectedSite.id} createdSite={isCreatingNewSite ? createdSite : selectedSite} onUpdateSuccess={onUpdateSiteSuccess}/>
                                         </Typography>
                                       </Box>
                                     )}
                                   </div>


                                </Widget>
                              </Grid>}

                              {!isRefetchingCustomer && ((!isCreatingNewCustomer && selectedCustomer && selectedCustomer.id > 0) || (isCreatingNewCustomer && createdCustomer && createdCustomer.id > 0)) &&
                                <Grid item xs={12} md={12} sm={12}>
                                <Widget
                                 className={classes.formDisplay}
                                 disableWidgetMenu noHeader>
                                 <AppBar position="static" color="default" style={{ marginTop: 10 }}>
                                   <Tabs value={customerInfoTabValue}
                                         onChange={handleCustomerInfoTabChange}
                                         indicatorColor="primary"
                                         textColor="primary"
                                         variant="fullWidth">
                                     <Tab {...a11yProps(0)} label="CUSTOMER NOTES"
                                                            value={0}/>
                                     <Tab {...a11yProps(1)} label="CUSTOMER DETAILS"
                                                            value={1}/>
                                   </Tabs>
                                 </AppBar>

                                  <div
                                    role="tabpanel"
                                    id="simple-tabpanel-customer-0"
                                    aria-labelledby="simple-tab-customer-0"
                                  >
                                    {customerInfoTabValue === 0 && (
                                      <Box p={3}>
                                        <Typography component="div">
                                        <UpdateCustomer key={isCreatingNewCustomer ? createdCustomer.id : selectedCustomer.id} isNotesOnly={true} createdCustomer={isCreatingNewCustomer ? createdCustomer : selectedCustomer} onUpdateSuccess={onUpdateCustomerSuccess}/>
                                        </Typography>
                                      </Box>
                                    )}
                                  </div>

                                  <div
                                    role="tabpanel"
                                    id="simple-tabpanel-customer-1"
                                    aria-labelledby="simple-tab-customer-1"
                                  >
                                    {customerInfoTabValue === 1 && (
                                      <Box p={3}>
                                        <Typography component="div">
                                        <UpdateCustomer key={isCreatingNewCustomer ? createdCustomer.id : selectedCustomer.id} createdCustomer={isCreatingNewCustomer ? createdCustomer : selectedCustomer} onUpdateSuccess={onUpdateCustomerSuccess}/>
                                        </Typography>
                                      </Box>
                                    )}
                                  </div>

                                </Widget>
                              </Grid>}
                          </Grid>
                        }
                        </Box>
                    </Grid>
                </Widget>
            </Grid>
        </Grid>
        </>
    )
}

export default AddJob
